module.exports = __webpack_public_path__ + "static/media/pay-forgot-password.8d17ec77.svg";